﻿import $ from 'jquery';

class StockFilterItem {
    constructor(el, index) {
        this.render(el, index);        
    }


    interation(event, filterGroup) {
        //console.log(event)
        if (filterGroup === this.current) {
            //console.log()
            filterGroup.close();
            this.current = null;
        }
        else {
            this.filterGroups.forEach(function (v) { v.close() });
            filterGroup.open();
            this.current = filterGroup;
        }
    }
   

    render(el, i) {
        this.element = $(el);
        this.groups = this.element.find('[data-component="c-stock-filter__group"]');
        this.filterGroups = [];
        for (var y = 0; y < this.groups.length; y++) {
            var group = new StockFilterGroup(this.groups[y], y);
            this.filterGroups.push(group);
        }
        this.current = this.filterGroups[0];
        this.current.open();

        this.element.on('filter-interation',  this.interation.bind(this) )

        


    }
}

class StockFilterGroup {
    constructor(el, index) {
        this.render(el, index);
    }


    calculateTime() {
        var msPerHeight = 1,
            minRange = 200,
            maxRange = 800,
            time = this.content.height() * msPerHeight;

        time = Math.min(time, maxRange);
        time = Math.max(time, minRange);

        return time;
    }

    group__CLICK(e) {
        if (e.type === "click" || (e.type === "keypress" && event.which === 13)) {
           
            this.element.trigger('filter-interation', [this]);

        }
    }

    open() {
        this.heading.addClass('expanded');
        this.content.slideDown(this.time);
    }

    close() {
        this.heading.removeClass('expanded');
        this.content.slideUp(this.time);
    }


    render(el, i) {
        this.element = $(el);
        this.heading = this.element.find('[data-ref="c-stock-filter__group-heading"]');
        this.content = this.element.find('[data-ref="c-stock-filter__group-content"]');
        this.time = this.calculateTime();

        this.heading.on('click keypress', this.group__CLICK.bind(this));
    }
}



class StockFilter {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }
    
    render(el, index) {
        new StockFilterItem(el, index);
    }
}

export default StockFilter;